import React from 'react';
import { MapContainer, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

import GpxRoute from '../mapcomponents/GpxRoute';
import LiveMarker from '../mapcomponents/LiveMarker';
import MapAutoCenter from '../mapcomponents/MapAutoCenter';
import CheckpointMarkers from '../mapcomponents/CheckpointMarkers';
import ClickLogger from '../mapcomponents/ClickLogger';

export default function MapView() {
  return (
    <div style={{ height: '70vh', width: '100%' }}>
      <MapContainer
        center={[53.162, 5.442]}
        zoom={13}
         zoomControl={false} 
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; OpenStreetMap contributors"
        />
        <GpxRoute />
        <LiveMarker />
        <MapAutoCenter />
        <CheckpointMarkers />
        <ClickLogger />
      </MapContainer>
    </div>
  );
}
